import { Position } from '../../../Geo'
import { IOTV_LCD_GatewayData } from '../IOTV_LCD_MessageType'

export type FlatGatewayData = Omit<IOTV_LCD_GatewayData, 'gatewayLocation' | 'deviceLocation'> & {
  deviceLat: number | undefined
  deviceLng: number | undefined
  deviceDOP: number | undefined
  gatewayLat: number | undefined
  gatewayLng: number | undefined
  gatewayDOP: number | undefined
}

export const getFlatGatewayData = (gatewayData: IOTV_LCD_GatewayData): FlatGatewayData => {
  const { gatewayLocation, deviceLocation, ...gatewayDataOthers } = gatewayData

  const { lat: gatewayLat, lng: gatewayLng, DOP: gatewayDOP } = gatewayLocation ?? {}

  const { lat: deviceLat, lng: deviceLng, DOP: deviceDOP } = deviceLocation ?? {}

  const flatRecord: FlatGatewayData = {
    ...gatewayDataOthers,
    deviceLat,
    deviceLng,
    deviceDOP,
    gatewayLat,
    gatewayLng,
    gatewayDOP,
  }

  return flatRecord
}

export const hydrateFlatGatewayData = (flatData: FlatGatewayData): IOTV_LCD_GatewayData => {
  const { deviceLat, deviceLng, deviceDOP, gatewayLat, gatewayLng, gatewayDOP, ...gatewayDataOthers } = flatData

  const deviceLocation: Position | undefined = deviceLat && deviceLng ? { lat: deviceLat, lng: deviceLng, DOP: deviceDOP } : undefined

  const gatewayLocation: Position | undefined = gatewayLat && gatewayLng ? { lat: gatewayLat, lng: gatewayLng, DOP: gatewayDOP } : undefined

  const res: IOTV_LCD_GatewayData = {
    ...gatewayDataOthers,
    gatewayLocation,
    deviceLocation,
  }

  return res
}
